import { combineReducers } from 'redux';
import { compareReducer } from './pages/Compare/actions';

export default function createReducer() {
  return combineReducers({
    comparedProducts: compareReducer,
  });
}
